import AuthorityService from '@/domain/security/authority.service';
import UserProfile from '@/domain/access/domain/profile.enum';

export default class UserAuthority {
  static async load(profile?: UserProfile) {
    const userAuthority = new UserAuthority();
    await userAuthority.load(profile);
    return userAuthority;
  }

  authorities: string[] = [];

  profile = UserProfile.USER;

  loaded = false;

  async load(profile?: UserProfile) {
    if (!this.loaded) {
      this.authorities = await AuthorityService.authorities();
      this.loaded = true;
    }
    if (profile) {
      this.profile = profile;
    }
  }

  isAdministrator(): boolean {
    return this.authorities.includes('ADMINISTRATOR');
  }

  isAuditor(): boolean {
    return this.authorities.includes('AUDITOR');
  }

  isSupervisor(): boolean {
    return this.profile === UserProfile.SUPERVISOR;
  }

  isGPProfile(): boolean {
    return this.profile === UserProfile.GP;
  }

  isCustomerSuccess(): boolean {
    return this.profile === UserProfile.CUSTOMER_SUCCESS;
  }

  isSimpleUser(): boolean {
    return this.profile === UserProfile.USER;
  }

  isAdminOrSupervisor(): boolean {
    return this.isAdministrator() || this.isSupervisor();
  }

  canEditContract(): boolean {
    return this.isAdministrator() || this.isSupervisor() || this.isCustomerSuccess();
  }

  canManageCalculation(): boolean {
    return this.isAdminOrSupervisor() || this.isGPProfile();
  }

  canChangeExpirationContract(): boolean {
    return this.isGPProfile() || this.isCustomerSuccess() || this.isAdminOrSupervisor();
  }
}
